import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Assembly from './pages/Assembly';
import Courses from './pages/Courses';
import News from './pages/News';
import NewsDetail from './pages/NewsDetail';
import Contact from './pages/Contact';
import OpenConnections from './pages/open-connections/OpenConnections';
import SobreEventos from './pages/SobreEventos';
import AgendaCompleta from './pages/AgendaCompleta';
import Localizacao from './pages/Localizacao';
import Inscricoes from './pages/Inscricoes';
import Login from './pages/admin/Login';
import Dashboard from './pages/admin/Dashboard';
import ProtectedRoute from './components/admin/ProtectedRoute';
import { AuthProvider } from './contexts/AuthContext';
import FirebaseDiagnostic from './components/FirebaseDiagnostic';

function App() {
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <Routes>
          {/* Rotas Públicas */}
          <Route path="/" element={
            <div className="min-h-screen bg-white">
              <Navbar />
              <main>
                <Home />
              </main>
              <Footer />
            </div>
          } />
          <Route path="/sobre" element={
            <div className="min-h-screen bg-white">
              <Navbar />
              <main>
                <About />
              </main>
              <Footer />
            </div>
          } />
          <Route path="/atividades" element={
            <div className="min-h-screen bg-white">
              <Navbar />
              <main>
                <Services />
              </main>
              <Footer />
            </div>
          } />
          <Route path="/assembleia" element={
            <div className="min-h-screen bg-white">
              <Navbar />
              <main>
                <Assembly />
              </main>
              <Footer />
            </div>
          } />

          <Route path="/cursos" element={
            <div className="min-h-screen bg-white">
              <Navbar />
              <main>
                <Courses />
              </main>
              <Footer />
            </div>
          } />
          <Route path="/noticias" element={
            <div className="min-h-screen bg-white">
              <Navbar />
              <main>
                <News />
              </main>
              <Footer />
            </div>
          } />
          <Route path="/noticias/:id" element={
            <div className="min-h-screen bg-white">
              <Navbar />
              <main>
                <NewsDetail />
              </main>
              <Footer />
            </div>
          } />
          <Route path="/contato" element={
            <div className="min-h-screen bg-white">
              <Navbar />
              <main>
                <Contact />
              </main>
              <Footer />
            </div>
          } />
          <Route path="/open-connections" element={<OpenConnections />} />
          
          {/* Rotas do Hotsite Open Connections + InCoDay */}
          <Route path="/hotsite/sobre" element={<SobreEventos />} />
          <Route path="/hotsite/agenda" element={<AgendaCompleta />} />
          <Route path="/hotsite/localizacao" element={<Localizacao />} />
          <Route path="/hotsite/inscricoes" element={<Inscricoes />} />
          
          {/* Rota de Diagnóstico (temporária) */}
          <Route path="/diagnostico" element={
            <div className="min-h-screen bg-gray-50">
              <main className="py-8">
                <FirebaseDiagnostic />
              </main>
            </div>
          } />
          
          {/* Rotas Administrativas */}
          <Route path="/admin/login" element={<Login />} />
          <Route path="/admin/dashboard" element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
